<template>
  <!-- 胚布档案列表 -->
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        v-if="$store.state.role.role.includes('material.create')"
        type="primary"
        @click="peiBuAdd()"
        style=""
        icon="el-icon-circle-plus"
        >新建</el-button
      >
      <el-button
        type="primary"
        @click="refreshPage()"
        style=""
        icon="el-icon-refresh"
        >刷新</el-button
      >
      <el-button
        type="primary"
        @click="initPrint('gongDanTable')"
        icon="el-icon-printer"
        >打印</el-button
      >
    </div>

    <div class="rzy-top-bar">
      <div class="rzy-top-bar">
        <div>状态</div>
        <div style="padding-left: 5px; padding-top: 5px;">
          <el-select
            @change="statusSelectChange()"
            clearable
            v-model="pageInfo.status"
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <d-query-input
        style="padding-left: 10px;"
        :options="options"
        @query="queryBySelect"
        @clear="clearQuery"
        width="340px"
        :pageInfo="pageInfo"
      />

      <div style="padding-left: 10px;">
        <el-date-picker
          @change="daterangeSelectChange()"
          v-model="daterangeSelectResult"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </div>

    <el-table
      :data="responseData"
      :header-cell-style="setHeaderCellStyle"
      :cell-style="setCellStyle"
      border
      stripe
      id="gongDanTable"
    >
      <!--行-->
      <el-table-column sortable prop="local_id" label="行" width="50">
      </el-table-column>

      <!--状态-->
      <el-table-column sortable prop="useBatch_change" label="状态" width="50">
      </el-table-column>

      <!--制单时间-->
      <el-table-column sortable prop="createTime" label="制单时间" width="120">
      </el-table-column>

      <!-- 胚布名称=物料名称 -->
      <el-table-column sortable prop="name" label="物料名称" width="220">
      </el-table-column>

      <!-- 胚布编号 = 物料编码 -->
      <el-table-column sortable prop="number" label="物料编码" width="120">
        <template slot-scope="scope">
          <el-link type="primary" @click="goToPeiBuDetails(scope.row.id)">
            {{ scope.row.number }}
          </el-link>
        </template>
      </el-table-column>

      <!--分组名称-->
      <el-table-column
        sortable
        prop="group_change"
        label="分组名称"
        width="120"
      >
      </el-table-column>

      <!--制单人-->
      <el-table-column sortable prop="issue" label="制单人" width="120">
      </el-table-column>

      <!--备注-->
      <el-table-column sortable prop="remark" label="备注"> </el-table-column>
    </el-table>

    <el-pagination
      style="text-align: center"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pageInfo.size"
      :current-page="pageInfo.page"
      :page-count="totalPages"
    >
    </el-pagination>
  </div>
</template>

<script>
import { peiBuDetails, dQueryInput } from "@/components/projectComponents";

export default {
  components: {
    dQueryInput,
  },

  name: "peiBuList",
  data() {
    return {
      responseData: [
        // 调试用假数据--正式版注释掉
        // {
        //     local_id: 1,
        //     status_change: '测试',
        //     createTime: '2022-04-19',
        //     number: '测试',
        //     name: '测试',
        // }
      ],
      remarksButton: [],
      pageInfo: {
        page: 1,
        size: 15,
        kind: "PB", //胚布 = PB, 原料 = YL。
        //下面是 隐藏的 查询参数--sta
        status: null, //配合useBatch使用的临时状态。
        useBatch: null, // 0: 停用 1: 启用

        startTime: null, //开始时间
        endTime: null, //结束时间
        name: null, //物料名称
        number: null, //物料编码
        //下面是 隐藏的 查询参数--end
      },
      totalPages: 0,
      // 查询--sta
      options: [
        {
          label: "物料编码",
          value: "number",
        },
        {
          label: "物料名称",
          value: "name",
        },
      ],
      // 查询--end

      // 状态下拉选择框--sta
      statusList: [
        {
          label: "停用",
          value: "1",
        },
        {
          label: "启用",
          value: "2",
        },
        {
          label: "全部",
          value: "3",
        },
      ],
      // 状态下拉选择框--end

      //日期范围选择控件 -- sta
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      daterangeSelectResult: "", //日期范围 选择的结果
      //日期范围选择控件 -- end
    };
  },
  created() {},

  methods: {
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      let that = this;
      let columns = [0, 1, 2, 4, 5, 6]; //想要改变列的索引
      if (columns.indexOf(columnIndex) > -1) {
        //有出现的话就返回center
        return "text-align:center;";
      } else {
        return "text-align:left;padding-left:15px;"; //没有的话就返回left
      }
    },
    setHeaderCellStyle({ row, column, rowIndex, columnIndex }) {
      let that = this;
      let columns = [0, 1, 2, 4, 5, 6]; //想要改变列的索引
      if (columns.indexOf(columnIndex) > -1) {
        //有出现的话就返回center
        return "text-align:center;padding-left:10px; ";
      } else {
        return "text-align:left;padding-left:15px;"; //没有的话就返回left
      }
    },
    // 跳转至新建胚布列表
    peiBuAdd() {
      this.$router.push({
        path: `peiBu/peiBuAdd`,
        query: {
          type: 0, //0=新建, 1=编辑.
          // wuLiaoId: XXX, 不需要
        },
      });
    },

    // 分页切换
    handleCurrentChange(newNum) {
      this.getPeiBuList(newNum);
    },

    // 获取胚布分页列表
    getPeiBuList(val) {
      this.pageInfo.page = val;

      // console.log('this.pageInfo.status=', this.pageInfo.status)
      if (this.pageInfo.status == 1) {
        // console.log('停用')
        this.pageInfo.useBatch = 0; //停用
      } else if (this.pageInfo.status == 2) {
        // console.log('启用')
        this.pageInfo.useBatch = 1; //启用
      } else {
        // console.log('为安全，强制清空')
        this.pageInfo.useBatch = null; //为安全，强制清空
      }

      this.$requestBase({
        url: "v1/material/list",
        method: "get",
        params: this.pageInfo,
      }).then((res) => {
        this.responseData = this.formatResponse(res.data.list);
        this.totalPages = res.data.pages;
      });
    },
    // 格式化胚布列表
    formatResponse(response) {
      response.forEach((item, index) => {
        item.local_id = index + 1;
        item.createTime = this.utils.timestampToTime(item.createTime, 2);

        switch (item.group) {
          case "PB":
            item.group_change = "胚布";
            break;
          case "YL":
            item.group_change = "原料";
            break;
          default:
            item.group_change = "无法识别的分组";
            break;
        }

        if (item.useBatch === true) {
          item.useBatch_change = "启用";
        } else {
          item.useBatch_change = "停用";
        }
      });
      return response;
    },
    // 路由至胚布详情
    goToPeiBuDetails(peiBuId) {
      this.$router.push(`peiBu/peiBuDetalis/${peiBuId}`);
    },
    // 在打印当前报表前，拼接title
    initPrint(id) {
      this.utils.printTable(id, `胚布档案列表`);
    },
    // 刷新
    refreshPage() {
      this.getPeiBuList(1);
      this.$Message.success("刷新成功");
    },
    // 条件查询
    queryBySelect(pageInfo) {
      this.pageInfo = pageInfo;
      this.getPeiBuList(1);
    },
    // 清空条件查询
    clearQuery(pageInfo) {
      this.pageInfo = pageInfo;
      this.getPeiBuList(1);
    },
    // 状态选择框，内容改变事件
    statusSelectChange() {
      // console.log('状态选择框，内容改变事件')
      this.refreshPage();
    },

    // 日期范围选择控件，内容改变事件
    daterangeSelectChange() {
      // console.log('daterangeSelectResult=', this.daterangeSelectResult)
      // console.log('daterangeSelectResult[0]=', this.daterangeSelectResult[0])
      // console.log('daterangeSelectResult[1]=', this.daterangeSelectResult[1])

      //开始时间 转 时间戳
      let m_date = new Date(this.daterangeSelectResult[0]);
      let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
      this.pageInfo.startTime = m_time;
      // console.log('startTime=', this.pageInfo.startTime)

      //结束时间 转 时间戳
      m_date = new Date(this.daterangeSelectResult[1]);
      m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
      this.pageInfo.endTime = m_time;
      // console.log('endTime=', this.pageInfo.endTime)

      this.refreshPage();
    },
  },
  mounted() {
    this.getPeiBuList(1);
  },
  activated() {
    this.getPeiBuList(1);
  },
};
</script>

<style lang="scss" scoped>
.define-table-container {
  margin-left: -10px !important;
}

p {
  // border: 1px solid #EBEEF5;
  // line-height: 0;
  padding: 0;
  margin: 0;
}
</style>
